import * as ko from "knockout";
import { CoOpStatementsViewModel } from "../ViewModels/CoOpStatementsViewModel";
import { CoOpStatementPdfsViewModel } from "../ViewModels/CoOpStatementPdfsViewModel";
import { PdfApi } from "../Apis/PdfApi";

export class CoOpStatements {
    private coOpStatementsViewModel: CoOpStatementsViewModel;
    private coOpStatementPdfsViewModel: CoOpStatementPdfsViewModel;
    private pdfApi: PdfApi;
    private $coOpStatementTab: JQuery;
    private $coOpStatementPdfsTab: JQuery;

    constructor() {
        this.$coOpStatementTab = $("#coOpStatementsTab");
        this.$coOpStatementPdfsTab = $("#coOpStatementPdfsTab");
        this.coOpStatementsViewModel = new CoOpStatementsViewModel();
        this.coOpStatementPdfsViewModel = new CoOpStatementPdfsViewModel();
        this.pdfApi = PdfApi.getInstance();

        if (this.$coOpStatementTab[0]) {
            ko.applyBindings(this.coOpStatementsViewModel, this.$coOpStatementTab[0]);
        }

        if (this.$coOpStatementPdfsTab[0]) {
            ko.applyBindings(this.coOpStatementPdfsViewModel, this.$coOpStatementPdfsTab[0]);
        }
    }

    init(): void {
        this.coOpStatementsViewModel.init();
        this.coOpStatementPdfsViewModel.init();
        this.attachPdfDownloadJquery();
    }

    private attachPdfDownloadJquery(): void {
        const self = this;
        self.$coOpStatementPdfsTab.on('click', '[id *= download]', function (e: any) {
            const id = $(this).attr('id');
            const fileName = $(this).attr('filename');
            const entryNo = Number.parseInt(id.split('download')[1]);
            const company = $(this).attr('company');
            self.pdfApi.downloadFile(entryNo, fileName, company);
        });
    }
}